import React from "react";
import Container from "../components/misc/Container";
import LayoutHomepage from "../layout/LayoutHomepage";
import { Link } from "react-router-dom";
// Import Icon
import { ReactComponent as ClockIcon } from "../assets/icons/icon-ios-timer.svg";
import { ReactComponent as ForkIcon } from "../assets/icons/icon-fork-eat.svg";
import Pagination from "../components/misc/Pagination";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";

// Resep
import DaginAyam from "../assets/images/resep/daging-goreng.svg";
import SotoAyam from "../assets/images/resep/sate-ayam.svg";
import Tumis from "../assets/images/resep/tumis.svg";

import classnames from "classnames";

const Recipe = () => {
  const recipeData = [
    {
      imgSrc: SotoAyam,
      imgAlt: "Soto ayam",
      recipeTitle: "Soto ayam lamongan",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Mudah",
      recipeRoutes : "/soto-lamongan"
    },
    {
      imgSrc: DaginAyam,
      imgAlt: "Daging goreng haji slamet",
      recipeTitle: "Daging goreng haji slamet",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Sedang",
      recipeRoutes : "/daging-goreng"
    },
    {
      imgSrc: Tumis,
      imgAlt: "Tumis Tahu Hijau",
      recipeTitle: "Tumis Tahu Hijau",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Sulit",
      recipeRoutes : "/tumis-tahu"
    },
    {
      imgSrc: SotoAyam,
      imgAlt: "Soto ayam",
      recipeTitle: "Soto ayam lamongan",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Mudah",
      recipeRoutes : "/soto-lamongan"
    },
    {
      imgSrc: DaginAyam,
      imgAlt: "Daging goreng haji slamet",
      recipeTitle: "Daging goreng haji slamet",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Sedang",
      recipeRoutes : "/daging-goreng"
    },
    {
      imgSrc: Tumis,
      imgAlt: "Tumis Tahu Hijau",
      recipeTitle: "Tumis Tahu Hijau",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Sulit",
      recipeRoutes : "/tumis-tahu"
    },
    {
      imgSrc: SotoAyam,
      imgAlt: "Soto ayam",
      recipeTitle: "Soto ayam lamongan",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Mudah",
      recipeRoutes : "/soto-lamongan"
    },
    {
      imgSrc: DaginAyam,
      imgAlt: "Daging goreng haji slamet",
      recipeTitle: "Daging goreng haji slamet",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Sedang",
      recipeRoutes : "/daging-goreng"
    },
    {
      imgSrc: Tumis,
      imgAlt: "Tumis Tahu Hijau",
      recipeTitle: "Tumis Tahu Hijau",
      recipeHour: "1",
      recipePortion: "4",
      recipeStatus: "Sulit",
      recipeRoutes : "/tumis-tahu"
    },
  ];

  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2">
              <div className="flex w-full mt-8 mb-2">
                <p className="flex items-center text-font-gray opacity-50">
                  <Link to="/homepage">Beranda </Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                <h1 className="text-font-gray">Resep</h1>
              </div>
              <div className="flex flex-wrap -mx-4">

              {recipeData.map((item, index) => (
                <div className="w-4/12 px-4 py-2">
                  <div className="bg-white rounded overflow-hidden shadow-lg mb-4 ">
                    <Link to={item.recipeRoutes}>
                      <div
                        style={{ backgroundImage: `url(${item.imgSrc})` }}
                        className="h-32 bg-cover"
                      ></div>
                    </Link>
                    <div className="px-6 py-4">
                      <div className="text-xl mb-2">{item.recipeTitle}</div>
                    </div>
                    <div className="px-6 py-4 flex items-center">
                      <div className="flex items-center">
                        <ClockIcon className="w-4 h-4 mr-2" />
                        <p className="text-sm font-semibold">{item.recipeHour} Jam</p>
                      </div>

                      <div className="flex items-center mx-auto">
                        <ForkIcon className="w-4 h-4 mr-2" />
                        <p className="text-sm font-semibold">{item.recipePortion} Porsi</p>
                      </div>
                      <span className={classnames("font-semibold",{ "text-green-100 bg-greenlight-100 border border-green-100 px-4 py-1" : item.recipeStatus === "Mudah",
                        "text-basic-orange bg-orange-100 border border-basic-orange px-4 py-1" : item.recipeStatus === "Sedang",
                        "text-red-600 bg-red-100 border border-red-600 px-4 py-1" : item.recipeStatus === "Sulit",
                    }, "rounded-md")}>
                        {item.recipeStatus}
                        </span>
                    </div>
                  </div>
                </div>
                ))}
              </div>
              <div className="flex justify-end my-8 w-full">
                <Pagination />
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default Recipe;
